/**
 * Designs queries
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const getFonts = graphql(
  gql`
    query GetFonts {
      fonts: getFonts {
        id
        family
        active
      }
    }
  `,
  { name: 'fontsData' }
)

export const getDIYItemQuery = gql`
  query getDIYItem($shortId: String!) {
    designItem: getDIYItem(shortId: $shortId) {
      id 
      shortId: short_id 
      name 
      shared 
      image 
      code 
      canvas 
      style_id 
      outputSvg: output_svg 
      createdAt: created_at
      canvas_files
      pro_design
      preflight_check
      proDesign: pro_design
      proCertified: pro_certified
      stitchingValue: flatlock
      predyedName: predyed_name
      stitchingName: flatlock_code
      zipperColor: zipper_color
      zipper2Color: zipper2_color
      bindingColor: binding_color
      bibColor: bib_brace_color
      high_resolution
      outputPng: output_png
      colors {
        id
        color
      }
      user {
        firstName: first_name
        lastName: last_name
      }
      testPrintTicket {
        id
        shortId: short_id
        userId: user_id
        designId: design_id
        requirePrintApproval: require_print_approval
        requesterFirstName: requester_first_name
        requesterLastName: requester_last_name
        createdAt: created_at
        type
        origin
        fabric
        status
        lastOrder {
          estimatedDate: estimated_date
        }
      }
      product {
        id
        productId: id
        yotpoId: yotpo_id
        name
        active
        discontinued
        glbEnabled: glb_enabled
        modelSize: model_size
        type: short_description
        testPrintFile: test_print_file
        onlyProDesign: only_pro_design
        shortDescription: short_description
        genderId: gender_id
        customizable: design_center
        description
        details
        relatedItemTag: related_item_tag
        materials: materials_info
        temperatures: temperature_range
        twoPieces: two_pieces
        collections
        isTopProduct
        predyedlabel
        branding
        bibBraceFullPrint: bibrace_fullprint
        hasPredyed: has_predyed
        zipperName: zipper_name
        zipper2Name: zipper2_name
        intendedUse: intended_use
        obj
        mtl
        label
        bumpMap: bump_map
        flatlock
        binding {
          white
          black
        }
        zipper {
          white
          black
        }
        zipper2 {
          white
          black
        }
        bibBrace {
          white
          black
        }
      }
      testPrints: test_prints {
        id
        file
        shortId: short_id
        ticketCode: ticket_code
        ticketShortId: ticket_short_id
        uploadedBy: uploaded_by
        uploadedAt: uploaded_at
        activatedBy: activated_by
        activatedAt: activated_at
        activated
        visibleBy: visible_by
        visibleAt: visible_at
        visible
        approvedBy: approved_by
        approvedAt: approved_at
        approved
        rejectNote: reject_note
        rejectedBy: rejected_by
        rejectedAt: rejected_at
        code
      }
    }
  }
`

export const getPredyedColors = gql`
  query getPredyedColors {
    getPredyedColors {
      id: short_id
      name
      code
    }
  }
`

export const getVariantsFromProduct = gql`
  query getVariants($id: Int!) {
    getVariants(id: $id) {
      id: short_id
      name
      icon
      default: is_default
      obj
      mtl
      glb
    }
  }
`

export const rejectPrintMutation = gql`
  mutation rejectPrint($shortId: String!, $rejectNote: String!) {
    rejectPrint(shortId: $shortId, rejectNote: $rejectNote) {
      message
    }
  }
`

export const approvePrintMutation = gql`
  mutation approvePrint($shortId: String!) {
    approvePrint(shortId: $shortId) {
      message
    }
  }
`

export const getColorsQuery = gql`
  query GetColors {
    colorsResult: getColors {
      colors
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DIYPrintApproval/data.ts